<template>
  <el-form
      ref="form"
      :model="form"
      label-width="180px">
    <el-radio-group
        v-model="form.targetingType">
      <el-radio
          :label="AdGroupEnum.SD.targetingType.AUDIENCES"
          disabled>
        查看再营销
        <div class="bid-type-help">
<!--          触达查看了与您选定标准匹配的商品详情页面的自定义受众。-->
          暂不支持创建，亚马逊改版中
        </div>
      </el-radio>
      <el-radio
          :label="AdGroupEnum.SD.targetingType.PRODUCT_TARGETING"
          class="block-radio">
        商品投放
        <div class="bid-type-help">选择要在亚马逊上投放的目标商品。</div>
      </el-radio>
    </el-radio-group>
  </el-form>
</template>

<script>
  import {formMixin} from "../../../../../../../../minxins";
  import {AdGroupEnum} from "../../../../../common/enum";

  export default {
    name: "app-target-type-picker",
    mixins: [formMixin],
    created() {
    },
    data() {
      return {
        AdGroupEnum: AdGroupEnum,
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "bid-picker";
  
  .block-radio {
    display: block;
    margin-top: 16px;
  }
  
  .picker-wrapper {
    margin-top: 5px;
    width: 400px;
    margin-left: 29px;
  }

</style>



